import { MutationTree } from 'vuex';
import { StayStoreType } from '@/types/store/stay-store.type';

export const mutations: MutationTree<StayStoreType> = {
  SET_STAYS(state, newValue) {
    state.stays = newValue;
  },
};
